import React, {ReactNode} from "react"

import FormatMessage from "@irati/utils/lang"

import {TD_STYLE} from "../../../../Table"
import {RedemptionsRenderer} from "../../../Renderers"

const columns = (formatMessage: FormatMessage, isRegion: boolean) => {
  const firstColHeader = isRegion ? "admin.reporting.platformColumn.country" : "admin.reporting.platformColumn.team"
  const secondColHeader = isRegion ? "admin.reporting.peopleTotalColumn.country" : "admin.reporting.peopleTotalColumn.team"
  return [
    {
      Header: formatMessage({id: firstColHeader}),
      id: "name",
      accessor: ({teamName}) => teamName.replace("platform.billingUnit.", ""),
      minWidth: 150,
      style: {...TD_STYLE, border: "none"}
    },
    {
      Header: formatMessage({id: secondColHeader}),
      accessor: "enabledUsers",
      minWidth: 150,
      style: {...TD_STYLE, border: "none"},
      headerStyle: {border: "none"}
    },
    {
      Header: formatMessage({id: "admin.reporting.perksByTeam.redemptions"}),
      accessor: "redemptions",
      minWidth: 150,
      Cell: (props): ReactNode => (
        <RedemptionsRenderer
          {...props}
          redemptionsAccessor="_original.redemptions"
          highestRate="_original.highest"
          lowestRate="_original.lowest"
        />
      ),
      style: {...TD_STYLE, border: "none"},
      headerStyle: {border: "none"}
    }
  ]
}
export default columns
